import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { routes } from "../config/routes";
import { AppDispatch, RootState } from "../store";
import { getCard } from "../store/slices/cardSlice";
import { getProductCategories } from "../store/slices/productCategoriesSlice";
import { fetchReviewsByCategory } from "../store/slices/reviewsByCategorySlice";
import { fetchReviews } from "../store/slices/reviewsSlice";
import {
  ProductCategories,
  Products,
  Review
} from "../types/types";

 type TPageData = {
  reviews: Review[];
  productCategories: ProductCategories[];
  card: Products[];
}

export const usePageData = (cardId: number = 8, skipReviewsFetch: boolean = false): TPageData => {
  const dispatch: AppDispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  const matchedRoute = routes.find((r) => r.path === location.pathname);
  const routeCategoryId = matchedRoute?.categoryId;

  useEffect(() => {
    dispatch(getCard(cardId));
    dispatch(getProductCategories());

    if (typeof routeCategoryId === "number") {
      dispatch(fetchReviewsByCategory(routeCategoryId));
    } else if (!skipReviewsFetch) {
      dispatch(fetchReviews());
    }
  }, [dispatch, cardId, routeCategoryId, skipReviewsFetch]);

  const allReviews = useSelector((state: RootState) => state.reviews.reviews);
  const reviewsByCategory = useSelector((state: RootState) => state.reviewsByCategory.reviews);

  const productCategories = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );
  const card = useSelector((state: RootState) => state.card.card);

  const reviews = typeof routeCategoryId === "number" ? reviewsByCategory : allReviews;

  return {
    reviews,
    productCategories,
    card,
  };
};
